module.exports = __webpack_public_path__ + "img/industrial-cut-1.7dae4a22.jpg";